module.exports = __webpack_public_path__ + "static/media/hourglass_bodytype.63d24314.png";